/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Qrdialogdescription2Inputs */

const en_qrdialogdescription2 = /** @type {(inputs: Qrdialogdescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The QR code points directly to ${i?.name}.`)
};

const de_qrdialogdescription2 = /** @type {(inputs: Qrdialogdescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Der QR-Code verweist direkt auf ${i?.name}.`)
};

/**
* | output |
* | --- |
* | "The QR code points directly to {name}." |
*
* @param {Qrdialogdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrdialogdescription2 = /** @type {((inputs: Qrdialogdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrdialogdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrdialogdescription2(inputs)
	return de_qrdialogdescription2(inputs)
});
export { qrdialogdescription2 as "qrDialogDescription" }